import styled from "styled-components";
import Button from "../../reusableComponents/Button/index.js";

export const ActionResponseContainer = styled.div`
  width: 60%;
  flex: 1.2;
  font-size: 1rem;
  padding: 1rem;
  margin-top: 0.8rem;
  @media (max-width: 768px) {
    padding-top: 5%;
    padding-left: 0%;
    width: 100%;
  }
`;

export const ResponseOptions = styled.div`
  height: 12%;
  display: flex;
  margin-left: 0.5rem;
  @media (max-width: 768px) {
    flex-direction: column;
    margin-left: 0;
  }
`;

export const ResponseComments = styled.div`
  padding-left: 2%;
  height: 55%;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    padding-left: 0;
  }
`;

export const CommentsHeader = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  div {
    margin-left: 1rem;
    color: lightgray;
    font-size: 0.8rem;
    font-style: italic;
    justify-content: flex-end;
  }
`;

export const ResponseActions = styled.div`
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 0.4rem;
  }
`;

export const ActionResponseButton = styled(Button)`
  height: 2rem;
  width: 4.4rem;
  margin-right: 0;
  @media (max-width: 768px) {
    margin-left: 0;
    padding: 0;
  }
`;

export const Label = styled.label`
  font-weight: 600;
  flex-grow: 1;
  margin-bottom: 0;
`;

export const ConfirmedSubmission = styled.p`
  font-size: 0.8125rem;
`;
